export const COMPANY_SHOW_CREATE_MODAL = "COMPANY_SHOW_CREATE_MODAL";
export const COMPANY_SHOW_EDIT_MODAL = "COMPANY_SHOW_EDIT_MODAL";
export const COMPANY_DELETED = "COMPANY_DELETED";
export const COMPANY_HIDE_CREATE_OR_EDIT_MODAL = "COMPANY_HIDE_CREATE_OR_EDIT_MODAL";
